import { Pipe, PipeTransform } from '@angular/core';
import { Currency } from '../../../model/enums/currency';
import { Language } from '../../../model/enums/language';
import {
  generateModelTranslationKey,
  ModelTranslationOutputType,
} from '../../../services/climate-engine/ccc-model-utility/generate-model-translation-key';
import { LanguageService } from '../../../services/language.service';
import { TranslationService } from '../../../services/translation-service';

@Pipe({
    name: 'translateUnit',
    pure: true,
    standalone: false
})
export class TranslateUnitPipe implements PipeTransform {
  constructor(private _languageService: LanguageService, private _translationService: TranslationService) {}
  transform(value: string, language?: Language, currency?: Currency): string {
    if (!language) {
      language = this._languageService.language;
    }
    const isMoneyUnit = value?.includes('money');
    if (isMoneyUnit) {
      const currencyCode = !!currency ? `${currency}` : '';
      const unitPart = value.replace('money', '');
      if (unitPart.length > 0) {
        const unit = unitPart.slice(1);
        const translatedUnit = this._translationService.translate(
          language,
          generateModelTranslationKey(ModelTranslationOutputType.Unit, unit)
        );
        return currencyCode + ' / ' + translatedUnit;
      }
      return currencyCode;
    }
    return value
      ? this._translationService.translate(
          language,
          generateModelTranslationKey(ModelTranslationOutputType.Unit, value)
        )
      : '';
  }
}
